import { connect } from "react-redux";
import BenchmarkReport from "./BenchmarkReport";
import { fetchSurveysFromTheOrg, handleChangeBenchmarkFilter, resetFilterContentsFromSavedData, updateOrganizationDataConfigurations } from "../../../../redux/actions";
import { fetchOrganizationDataConfigurations } from "../../../../redux/actions/BenchmarkFilterAction/Helper/fetchOrgBenchmarkConfigurations";


const mapStateToProps = (state) => ({
    benchmarkFilters: state.BenchmarkFilteringReducer.benchmarkFilters,
    isSurveyListFetched: state.BenchmarkFilteringReducer.isSurveyListFetched,
    fetchSurveyLists: state.BenchmarkFilteringReducer.fetchSurveyLists,
    fetchOrganizationConfigurationsApi: state.BenchmarkFilteringReducer.fetchOrganizationConfigurationsApi,
    isOrgDetailsFetched: state.BenchmarkFilteringReducer.isOrgDetailsFetched,
    updateOrgConfigurationsApi: state.BenchmarkFilteringReducer.updateOrgConfigurationsApi


});

const mapDispatchToProps = (dispatch) => ({
    resetFilterContentsFromSavedData: (payload) => dispatch(resetFilterContentsFromSavedData(payload)),
    updateOrganizationDataConfigurations: (payload, cb) => dispatch(updateOrganizationDataConfigurations(payload, cb)),
    fetchOrganizationDataConfigurations: (payload, cb) => dispatch(fetchOrganizationDataConfigurations(payload, cb)),
    handleChangeBenchmarkFilter: (payload) => dispatch(handleChangeBenchmarkFilter(payload)),
    fetchSurveysFromTheOrg: (payload) => dispatch(fetchSurveysFromTheOrg(payload)),


});

export default connect(mapStateToProps, mapDispatchToProps)(BenchmarkReport);
